<script setup lang="ts">
import VInlineButton from "@magnit/core/src/components/VInlineButton/VInlineButton.vue";
import VHidden from "@magnit/core/src/components/VHidden/VHidden.vue";
import VIcon from "@magnit/icons/src/components/VIcon/VIcon.vue";
import FilterIcon from "@magnit/icons/src/assets/icons/filter-24.svg";
import { useAnalyticManager } from "@magnit/analytic-events";

const props = withDefaults(
  defineProps<{
    mark?: boolean;
    analyticsPayload?: Record<string, unknown>;
    analyticsSender?: (name: string, params?: Record<string, unknown>) => void;
  }>(),
  {
    analyticsPayload: () => ({}),
    analyticsSender: undefined,
  },
);

const emit = defineEmits<{
  click: [];
}>();

const { send: nativeSend } = useAnalyticManager();
const send = props.analyticsSender || nativeSend;

const onClick = () => {
  send("Filter:List:Click", {
    ...props.analyticsPayload,
  });
  emit("click");
};
</script>

<template>
  <VHidden :hide="{ xs: false, xl: true }">
    <div class="catalog-filters-button">
      <VInlineButton
        icon-position="left"
        size="l"
        theme="secondary"
        @click="onClick"
      >
        <template #icon>
          <VIcon color="inherit">
            <FilterIcon />
          </VIcon>
        </template>
        Фильтры
      </VInlineButton>
      <div v-if="mark" class="catalog-filters-button__mark" />
    </div>
  </VHidden>
</template>

<style lang="postcss" scoped>
.catalog-filters-button {
  position: relative;

  &__mark {
    position: absolute;
    display: block;
    background: var(--pl-project-core-primary);
    border-radius: 50%;
    width: 8px;
    height: 8px;
    top: -2px;
    right: -2px;
    transform: translateX(50%);
  }
}
</style>
